import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const BookAppointment = lazy(() => import('./book-appointment'));

export function BookAppointmentPage() {
  return (
    <Suspense fallback={<Loading />}>
      <BookAppointment />
    </Suspense>
  );
}
